import { render } from "./EmailVerificationFailed.vue?vue&type=template&id=a74cfdb6"
import script from "./EmailVerificationFailed.vue?vue&type=script&lang=js"
export * from "./EmailVerificationFailed.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__